import {
  SET_SO_DISPLAY_ID, SET_SO_CUSTOMER_ID, SET_SO_PRODUCTS, SET_SO_PAYMENT_INFO, SET_NEW_SO_INFO, CLEAR_NEW_SO
} from 'redux/actionTypes';

export const setNewSODisplayId = value => ({
  type: SET_SO_DISPLAY_ID,
  payload: value
});

export const setNewSOCustomerId = value => ({
  type: SET_SO_CUSTOMER_ID,
  payload: value
});

export const setNewSOProducts = value => ({
  type: SET_SO_PRODUCTS,
  payload: value
});

export const setNewSOPaymentInfo = value => ({
  type: SET_SO_PAYMENT_INFO,
  payload: value
});

export const setNewSOInfo = data => ({
  type: SET_NEW_SO_INFO,
  payload: data
});

export const clearNewSO = () => ({
  type: CLEAR_NEW_SO
});